import { Phone, PhoneOff, PhoneIncoming } from 'lucide-react';
import { useVoice } from '@/context/VoiceContext';

export default function IncomingCallModal() {
  const { incomingCall, callerInfo, acceptIncoming, rejectIncoming } = useVoice();

  if (!incomingCall) return null;

  const displayName = callerInfo?.name || callerInfo?.number || 'Unknown Caller';

  return (
    <div className="fixed inset-0 z-[100] flex items-end justify-center pb-8 pointer-events-none">
      <div
        data-testid="incoming-call-modal"
        className="
          pointer-events-auto
          bg-[#0F172A] border border-white/10 rounded-2xl shadow-2xl
          w-80 p-5 animate-slide-up
        "
      >
        {/* Incoming indicator */}
        <div className="flex items-center gap-2 mb-3">
          <div className="w-8 h-8 rounded-full bg-blue-500/20 flex items-center justify-center">
            <PhoneIncoming className="w-4 h-4 text-blue-400" strokeWidth={2} />
          </div>
          <div>
            <p className="text-[10px] text-slate-400 uppercase tracking-wider font-semibold">
              Incoming Call
            </p>
            <p
              data-testid="incoming-caller-name"
              className="text-white font-semibold text-sm truncate max-w-[180px]"
            >
              {displayName}
            </p>
          </div>
        </div>

        <div className="flex gap-3">
          <button
            data-testid="incoming-reject-btn"
            onClick={rejectIncoming}
            className="
              flex-1 flex items-center justify-center gap-2
              bg-red-600 hover:bg-red-700 text-white text-sm font-medium
              py-2.5 rounded-xl transition-all
            "
          >
            <PhoneOff className="w-4 h-4" />
            Decline
          </button>
          <button
            data-testid="incoming-accept-btn"
            onClick={acceptIncoming}
            className="
              flex-1 flex items-center justify-center gap-2
              bg-emerald-600 hover:bg-emerald-700 text-white text-sm font-medium
              py-2.5 rounded-xl transition-all
            "
          >
            <Phone className="w-4 h-4" />
            Accept
          </button>
        </div>
      </div>
    </div>
  );
}
